module.exports = __webpack_public_path__ + "static/media/Cross.1b34ede2.svg";